import type {
  CreateReportBody,
  CreateReportResponse,
} from '@eppendorf/vnls-reporting-service-utils';
import { useMutation } from '@tanstack/react-query';

import { fetcher } from '$shared/fetch';
import { REPORTING_SERVICE_BASE_PATH } from '$shared/utils/api-paths';

export const auditExportQueryKey = 'audit-export';

/**
 * Hook to create/request a new audit trail export report
 */
export const useCreateAuditExport = () =>
  useMutation<CreateReportResponse, Error, CreateReportBody>({
    mutationFn: async (params: CreateReportBody) => {
      const response = await fetcher.post<CreateReportBody, CreateReportResponse>(
        REPORTING_SERVICE_BASE_PATH,
        params,
      );
      return response.data;
    },
  });
